export default __webpack_public_path__ + "static/media/LexusMonogram-White.db16aa90.png";